import { WelcomeBanner } from 'features/navigation';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { OfferListEmpty, OfferListError } from './components';
import OfferList from './containers/OfferList';
import { usePageStatus } from './hooks';
import { offersListStatusSelector } from './store';

function CandidateOfferListPage() {
    const status = usePageStatus();
    const offersListStatus = useSelector(offersListStatusSelector);

    if (status === 'error') {
        return <WithBanner><OfferListError /></WithBanner>;
    }

    if (offersListStatus === 'empty') {
        return <WithBanner><OfferListEmpty /></WithBanner>;
    }

    return <WithBanner><OfferList /></WithBanner>;
}

function WithBanner({ children }: { children: React.ReactNode }) {
    return (
        <>
            <WelcomeBanner pageType="offers" />
            { children }
        </>
    );
}

export default memo(CandidateOfferListPage);
